export enum UrlParams {
  RedirectUrl = 'redirectUrl',
  RedirectRoleKey = 'redirectRoleKey'
}
